import './context_menu.scss';

export const SHOW_CONTEXT_MENU_EVENT = 'ShowContextMenu';
export const HIDE_CONTEXT_MENU_EVENT = 'HideContextMenu';
